import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPostscriptFavicon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 17.5C2 10.8726 7.37258 5.5 14 5.5H19.5C25.299 5.5 30 10.201 30 16C30 21.799 25.299 26.5 19.5 26.5H2V17.5Z",
			fill: "#5724E9"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 12,
			cy: 14,
			rx: 2,
			ry: 4.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 19,
			cy: 14,
			rx: 2,
			ry: 4.5,
			fill: "white"
		})
	]
});
export default SvgPostscriptFavicon;
